<script lang="ts">
  import Seo from '$components/seo.svelte';
  import RichText from '$components/rich-text.svelte';
  import Accordion from '$components/accordion.svelte';

  import { cn } from '$lib/utils';

  import type { LegalPage } from './content';

  export let data: LegalPage;
</script>

<Seo
  title={data.story.content.seo_title}
  description={data.story.content.seo_description}
  image={data.story.content.seo_og_image}
/>
<div class="pb-14 pt-20 lg:py-30">
  <div class="px-4">
    {#if data.story.content.introductory_text}
      <section class="mx-auto lg:max-w-[600px]">
        {#if data.story.name}
          <h1 class="mb-6 text-4xl font-semibold">{data.story.name}</h1>
        {/if}
        <RichText
          doc={data.story.content.introductory_text}
          class={cn(
            'mb-14',
            '[&>p]:text-md-body [&>p]:text-primary/96',
            '[&>p+*]:mt-6',
            '[&>h2]:text-md [&>h2]:font-semibold [&>h2]:text-primary/96',
            '[&>h2+*]:mt-1'
          )}
        />
      </section>
    {/if}
  </div>

  <div class="px-2">
    {#if data.story.content.accordions}
      <section class="mx-auto flex flex-col gap-2 lg:max-w-[600px]">
        {#each data.story.content.accordions as accordion}
          <Accordion as="h2" variant="product" title={accordion.title}>
            <RichText
              doc={accordion.content}
              class={cn(
                '[&>p]:text-md-body [&>p]:text-primary/96',
                '[&>p+*]:mt-6',
                '[&>h3]:text-md [&>h3]:font-semibold [&>h3]:text-primary/96',
                '[&>h3+*]:mt-1',
                '[&>ol]:list-inside [&>ol]:list-decimal-leading-zero',
                '[&>ol+*]:mt-6',
                '[&>ol>li]:text-md-body [&>ol>li]:text-primary/96',
                '[&>ol>li>p]:inline',
                '[&>ol>li+li]:mt-6',
                '[&>ol>li::marker]:text-accent'
              )}
            />
          </Accordion>
        {/each}
      </section>
    {/if}
  </div>
</div>
